export default __webpack_public_path__ + "static/elevatyr-e87bcf1084bdf770594a959b0994f10b.svg";